const langCN = {
    name: "姓名",
    navList: JSON.stringify(["首页", "公司简介", "产品&服务", "媒体之声", "联系我们"]),
    navListLevel: JSON.stringify(["连接服务", "生态服务"]),
    about: JSON.stringify([
        { title: "公司简介", content: `优咔科技是万马科技(300698)全资子公司，是车联网领域的高科技企业，是全球一站式的车联网服务提供商和方案解决商，以优咔揽海（Yoocar Connect）车联网连接管理服务和产品为基座，向车企提供车联网连接管理产品与服务。同时依托不断积累的车联网专业能力，打造了优咔遨云(Yoocar DriveCloud)自动驾驶综合解决方案，助力车企客户建立数据采集、数据管理、算法训练等关键能力，帮助车企构建数据驱动、安全可控的自动驾驶云。` },
        { title: "行业影响力", content: `公司坚持合规、规范地运用先进技术，加入GSMA、5GAA、TAF、CCSA等通信组织会员，积极参与行业规范的制定。` },
        { title: "公司资质", content: `公司拥有一支在3/4/5G移动通信、IT网络、计算机软件、车联网运营领域有丰富经验的技术团队，已经积累多项车联网连接管理和生态运营相关的发明专利、实用新型专利及软件著作权/软件登记证书。` },
        { title: "合作伙伴" },
    ]),
    about_2: JSON.stringify([
        { title: "GSMA及eSIM工作组成员", imgName: "GSMA.png" },
        { title: "5GAA协会成员", imgName: "5GAA.png" },
        { title: "TAF成员单位", imgName: "TAF.png" },
        { title: "CCSA成员单位", imgName: "CCSA.png" },
    ]),
    about_3: JSON.stringify([
        { title: "多项发明及实用新型专利", imgName: "about_3_1.png" },
        { title: "eSIM及连接管理方向的软件著作权20余项", imgName: "about_3_2.png" },
        { title: "ISO 9001证书", imgName: "about_3_3.png" },
        { title: "ISO 27001证书", imgName: "about_3_4.png" },
        { title: "互联网内容服务许可证，互联网在线交易许可证", imgName: "about_3_5.png" },
        { title: "电信增值业务许可证", imgName: "about_3_6.png" },
    ]),
    product: JSON.stringify([
        { title: "优咔全球一站式车联解决方案", content: `与基础通信运营商开展合作，依托全球领先的车联网业务运营平台，向车企提供前装车联网运营服务，帮助车企客户使用高质量、易管理、可运营的4G/5G连接。`, btnText: "了解更多" },
        { title: "车联网生态服务平台", content: `积极拓展车联网产业链，打造面向车主的内容与权益服务集成平台，向车厂提供车联网生态服务的规划咨询、平台工具、服务运营，帮助车企向车主提供智能愉悦的用车体验。`, btnText: "了解更多" },
    ]),
    news: JSON.stringify({ title: "媒体之声", doc: `公司最新动态/车联网行业动态` }),
    news_list: JSON.stringify([
        { title: "优咔科技X亿咖通X锐捷车联签署车载后装战略协议", imgName: "news_1.png" },
        { title: "优咔科技与东软集团签署战略合作协议", imgName: "news_2.png" }
    ]),
    contact: JSON.stringify({ title: "加入我们", doc: `优咔科技近期招聘岗位` }),
    recruit: JSON.stringify(["软件工程师（Android开发方向）", "软件工程师（Java开发方向）", "运维开发工程师 （云开发方向）", "产品经理&专家"]),
    contact_cooperation: JSON.stringify([
        {
            title: "联系我们",
            list: [
                { content: "上海市徐汇区龙耀路175号星扬西岸中心", imgName: "address.png" },
                { content: "021-54979568", imgName: "photo.png" },
                { content: "客服电话：400-101-3166", imgName: "photo.png" },
            ]
        },
        {
            title: "合作咨询",
            list: [
                { content: "招聘：recruiting@yoocar.com", imgName: "email.png" },
                { content: "合作：partner@yoocar.com", imgName: "email.png" },
                { content: "客服：service@yoocar.com", imgName: "email.png" },
            ]
        }
    ]),
    wechat_tips: "扫码关注“优咔科技”"
}
export default langCN